// src/components/BookingDateTimeCard.js
import React from 'react';
import CalendarSelector from './CalendarSelector';
import TimeGridSelector from './TimeGridSelector';

function BookingDateTimeCard({ 
    selectedDate, 
    onDateSelect, 
    disabledDays,
    reservationType,
    availableTimes, 
    selectedTime, 
    onTimeSelect 
}) {
    return (
        // Reduzimos o padding no mobile (p-5 em vez de p-6) para dar mais área útil
        <div className="bg-white/60 backdrop-blur-sm p-5 sm:p-8 md:p-10 rounded-[2rem] border border-[#dbcdac]/30 shadow-sm">
            
            {/* Header da Seção */}
            <div className="mb-8">
                <div className="flex items-center gap-3 mb-2">
                    <span className="flex items-center justify-center w-8 h-8 rounded-full bg-[#dbcdac]/30 text-[#971253] font-serif font-bold text-sm">
                        2
                    </span>
                    <h2 className="font-serif text-2xl md:text-3xl text-[#971253]">Quando vamos jogar?</h2>
                </div>
                <p className="text-stone-500 font-light ml-11 text-sm md:text-base">
                    Reservas disponíveis de Sexta a Domingo.
                </p>
            </div>

            {/* Grid Dividido (Calendário Esq | Horários Dir) */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-start">
                
                {/* Lado Esquerdo: Calendário */}
                {/* Mudamos de md:justify-end para md:justify-center para o calendário não ficar torto no desktop */}
                <div className="w-full">
                    <CalendarSelector 
                        selectedDate={selectedDate}
                        onDateSelect={onDateSelect}
                        reservationType={reservationType}
                        disabledDays={disabledDays}
                    />
                </div>

                {/* Lado Direito: Grid de Horários */}
                <div className="w-full">
                    <TimeGridSelector 
                        availableTimes={availableTimes}
                        selectedTime={selectedTime}
                        onTimeSelect={onTimeSelect}
                        selectedDate={selectedDate}
                    />
                </div>

            </div>
        </div>
    );
}

export default BookingDateTimeCard;